<template>
  <div class="box">
    <Header />
    <Main>
      <router-view></router-view>
    </Main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style scoped lang="less">
.box {
  Main {
    margin-top: 80px;
  }
}
</style>
